import { jsxs, jsx } from 'react/jsx-runtime';
import { M as MemberLink, b as MEMBER_LINK_VARIANT_MOBILE } from './component-DV6bFT4K.js';
import { S as SgcmLogo, b as SGCM_LOGO_VARIANT_MOBILE } from './component-D5qJ4zZ9.js';
import { HeartOutlined, Home, NewCars, UsedCars, ElectricVehicle, CarLoan, RentalCars, SellCars, EShop, Md, Accessories, Insurance, Articles, Forum, Resources, Sgcm } from '@sgcmpteltd/uikit-react';
import { HybridVehicle } from '@sgcmpteltd/uikit-react/components/icons';
import { S as SGCM_APP_PLATFORM_IOS } from './constants-CKDihI9A.js';
import { a as HEADER_ITEM_TYPE_SINGLE, H as HEADER_ITEM_TYPE_MULTITPLE } from './constants-DS8JUgTg.js';
import { M as MenuItem$1 } from './component--4bD6niJ.js';
import { M as MenuItem } from './component-oulYyjVo.js';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const headerConfigList = os => [
    {
        key: 'shortlist',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: HeartOutlined,
                link: {
                    href: 'https://m.sgcarmart.com/main/shortlist.php',
                    key: 'myShortlist',
                    text: 'My Shortlist',
                },
            },
        ],
    },
    {
        key: 'home',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Home,
                link: {
                    href: 'https://m.sgcarmart.com/index.php',
                    key: 'home',
                    text: 'Home',
                },
            },
        ],
    },
    {
        key: 'buyCars',
        group: [
            {
                type: HEADER_ITEM_TYPE_MULTITPLE,
                icon: NewCars,
                title: 'New Cars',
                linkList: [
                    {
                        href: 'https://m.sgcarmart.com/new_cars/index.php',
                        key: 'findNewCars',
                        text: 'Find New Cars',
                    },
                    {
                        href: 'https://m.sgcarmart.com/new_cars/promotionlist.php',
                        key: 'newCarPromotions',
                        text: 'New Car Promotions',
                    },
                    {
                        href: 'https://sgcarmart.com/coe-price',
                        key: 'coeResults',
                        text: 'COE Results',
                    },
                ],
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: UsedCars,
                link: {
                    href: 'https://sgcarmart.com/used-cars',
                    key: 'usedCars',
                    text: 'Used Cars',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: ElectricVehicle,
                link: {
                    href: 'https://sgcarmart.com/electric-vehicle',
                    key: 'electricVehicle',
                    text: 'Electric Vehicle',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: HybridVehicle,
                link: {
                    href: 'https://sgcarmart.com/hybrid-vehicle',
                    key: 'hybridVehicle',
                    text: 'Hybrid Vehicle',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: CarLoan,
                link: {
                    href: 'https://sgcarmart.com/car-loan',
                    key: 'carLoan',
                    text: 'Car Loan',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: RentalCars,
                link: {
                    href: 'https://m.sgcarmart.com/car_rental/index.php',
                    key: 'rentalCars',
                    text: 'Rental Cars',
                },
            },
        ],
    },
    {
        key: 'sellCars',
        group: [
            {
                type: HEADER_ITEM_TYPE_MULTITPLE,
                icon: SellCars,
                title: 'Sell My Car',
                linkList: [
                    {
                        href: 'https://m.sgcarmart.com/sell_cars/index.php',
                        key: 'postAnAd',
                        text: 'Post an Ad',
                    },
                    {
                        href: 'https://m.sgcarmart.com/quotz/sell-by-bidding.php?type=sbbid',
                        key: 'sellByBidding',
                        text: 'Sell by Bidding',
                    },
                    {
                        href: 'https://m.sgcarmart.com/tools_tips/consignment.php',
                        key: 'consignment',
                        text: 'Consignment',
                    },
                    {
                        href: 'https://m.sgcarmart.com/quotz/index.php?type=fv',
                        key: 'freeCarValuation',
                        text: 'Free Car Valuation',
                    },
                    {
                        href: 'https://www.sgcarmart.com/advertiser/login',
                        key: 'advertisersLogin',
                        text: 'Advertiser\'s Login',
                    },
                ],
            },
        ],
    },
    {
        key: 'carsAssistance',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: EShop,
                link: {
                    href: 'https://www.sgcarmart.com/shop',
                    key: 'eShop',
                    text: 'e-Shop',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Md,
                link: {
                    href: 'https://m.sgcarmart.com/directory/index.php',
                    key: 'motorDirectory',
                    text: 'Motor Directory',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Accessories,
                link: {
                    href: 'https://m.sgcarmart.com/accessories/index.php',
                    key: 'accessories',
                    text: 'Accessories',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Insurance,
                link: {
                    href: 'https://sgcarmart.com/car-insurance',
                    key: 'insurance',
                    text: 'Insurance',
                },
            },
        ],
    },
    {
        key: 'articles',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Articles,
                link: {
                    href: 'https://sgcarmart.com/articles',
                    key: 'articles',
                    text: 'Articles',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Forum,
                link: {
                    href: 'https://m.sgcarmart.com/forum/index.php',
                    key: 'forum',
                    text: 'Forum',
                },
            },
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Resources,
                link: {
                    href: 'https://www.sgcarmart.com/resources',
                    key: 'resources',
                    text: 'Resources',
                },
            },
        ],
    },
    {
        key: 'app',
        group: [
            {
                type: HEADER_ITEM_TYPE_SINGLE,
                icon: Sgcm,
                link: {
                    target: '_blank',
                    href: os === SGCM_APP_PLATFORM_IOS ? 'https://www.sgcarmart.com/phpads/www/delivery/ck.php?bannerid=2274' : 'https://www.sgcarmart.com/phpads/www/delivery/ck.php?bannerid=2275',
                    key: 'downloadOurApp',
                    text: 'Download Our App',
                },
            },
        ],
    },
];

var css_248z = ".SGCM_UIKIT_NEXT_Content_contentRoot_4ps1c_1 {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  color: black;\n  font-size: 1.2rem;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerSgcmLogo_4ps1c_9 {\n  flex: none;\n  padding: 20px 15px;\n  background-color: white;\n  line-height: 0;\n}\n\n.SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_4ps1c_16 {\n  overflow: auto;\n  flex: 1;\n}\n@supports (scrollbar-width: none) {\n  .SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_4ps1c_16 {\n    scrollbar-width: none;\n  }\n}\n.SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_4ps1c_16::-webkit-scrollbar {\n  display: none;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerUserLogin_4ps1c_29 {\n  padding: 0 15px 20px;\n  background-color: white;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerGuestLinks_4ps1c_34 {\n  display: flex;\n  align-items: center;\n  column-gap: 12px;\n}\n\n.SGCM_UIKIT_NEXT_Content_dividerLinkMember_4ps1c_40 {\n  width: 1px;\n  height: 12px;\n  background-color: #dfdfdf;\n}\n\n.SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_4ps1c_46:not(:last-child) {\n  border-bottom: 1px solid #dfdfdf;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixZQUFZO0VBQ1osc0JBQXNCO0VBQ3RCLFlBQVk7RUFDWixpQkFBaUI7QUFDbkI7O0FBRUE7RUFDRSxVQUFVO0VBQ1Ysa0JBQWtCO0VBQ2xCLHVCQUF1QjtFQUN2QixjQUFjO0FBQ2hCOztBQUVBO0VBQ0UsY0FBYztFQUNkLE9BQU87QUFDVDtBQUNBO0VBQ0U7SUFDRSxxQkFBcUI7RUFDdkI7QUFDRjtBQUNBO0VBQ0UsYUFBYTtBQUNmOztBQUVBO0VBQ0Usb0JBQW9CO0VBQ3BCLHVCQUF1QjtBQUN6Qjs7QUFFQTtFQUNFLGFBQWE7RUFDYixtQkFBbUI7RUFDbkIsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0UsVUFBVTtFQUNWLFlBQVk7RUFDWix5QkFBeUI7QUFDM0I7O0FBRUE7RUFDRSxnQ0FBZ0M7QUFDbEMiLCJmaWxlIjoic3R5bGVzLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRlbnRSb290IHtcbiAgZGlzcGxheTogZmxleDtcbiAgaGVpZ2h0OiAxMDAlO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBjb2xvcjogYmxhY2s7XG4gIGZvbnQtc2l6ZTogMS4ycmVtO1xufVxuXG4uY29udGFpbmVyU2djbUxvZ28ge1xuICBmbGV4OiBub25lO1xuICBwYWRkaW5nOiAyMHB4IDE1cHg7XG4gIGJhY2tncm91bmQtY29sb3I6IHdoaXRlO1xuICBsaW5lLWhlaWdodDogMDtcbn1cblxuLmNvbmF0aW5lck1lbnVJdGVtTGlzdCB7XG4gIG92ZXJmbG93OiBhdXRvO1xuICBmbGV4OiAxO1xufVxuQHN1cHBvcnRzIChzY3JvbGxiYXItd2lkdGg6IG5vbmUpIHtcbiAgLmNvbmF0aW5lck1lbnVJdGVtTGlzdCB7XG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xuICB9XG59XG4uY29uYXRpbmVyTWVudUl0ZW1MaXN0Ojotd2Via2l0LXNjcm9sbGJhciB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbi5jb250YWluZXJVc2VyTG9naW4ge1xuICBwYWRkaW5nOiAwIDE1cHggMjBweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7XG59XG5cbi5jb250YWluZXJHdWVzdExpbmtzIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgY29sdW1uLWdhcDogMTJweDtcbn1cblxuLmRpdmlkZXJMaW5rTWVtYmVyIHtcbiAgd2lkdGg6IDFweDtcbiAgaGVpZ2h0OiAxMnB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZGZkZmRmO1xufVxuXG4uY29udGFpbmVySGVhZGVySXRlbUdyb3VwOm5vdCg6bGFzdC1jaGlsZCkge1xuICBib3JkZXItYm90dG9tOiAxcHggc29saWQgI2RmZGZkZjtcbn0iXX0= */";
var styles = {"contentRoot":"SGCM_UIKIT_NEXT_Content_contentRoot_4ps1c_1","containerSgcmLogo":"SGCM_UIKIT_NEXT_Content_containerSgcmLogo_4ps1c_9","conatinerMenuItemList":"SGCM_UIKIT_NEXT_Content_conatinerMenuItemList_4ps1c_16","containerUserLogin":"SGCM_UIKIT_NEXT_Content_containerUserLogin_4ps1c_29","containerGuestLinks":"SGCM_UIKIT_NEXT_Content_containerGuestLinks_4ps1c_34","dividerLinkMember":"SGCM_UIKIT_NEXT_Content_dividerLinkMember_4ps1c_40","containerHeaderItemGroup":"SGCM_UIKIT_NEXT_Content_containerHeaderItemGroup_4ps1c_46"};
styleInject(css_248z);

const Content = ({ baseUrlMap, user, os }) => (jsxs("div", { className: styles.contentRoot, children: [jsx("div", { className: styles.containerSgcmLogo, children: jsx(SgcmLogo, { baseUrlMap: baseUrlMap, variant: SGCM_LOGO_VARIANT_MOBILE }) }), jsxs("div", { className: styles.conatinerMenuItemList, children: [jsx("div", { className: styles.containerUserLogin, children: jsx(MemberLink, { user: user, variant: MEMBER_LINK_VARIANT_MOBILE }) }), headerConfigList(os).map(({ key, group }) => (jsx("div", { className: styles.containerHeaderItemGroup, children: group.map((groupData) => {
                        const { type, icon } = groupData;
                        if (type === HEADER_ITEM_TYPE_SINGLE) {
                            const { link } = groupData;
                            return (jsx(MenuItem, { icon: icon, link: link }, `${key}-${link.href}`));
                        }
                        if (type === HEADER_ITEM_TYPE_MULTITPLE) {
                            const { title, linkList } = groupData;
                            return (jsx(MenuItem$1, { icon: icon, linkList: linkList, title: title }, `${key}-${title}`));
                        }
                        return null;
                    }) }, key)))] })] }));

export { Content as C };
//# sourceMappingURL=component-BykU10Ag.js.map
